/* eslint-disable @typescript-eslint/no-empty-function */
import Cookies from 'js-cookie';
import concat from 'lodash/fp/concat';
import filter from 'lodash/fp/filter';
import flow from 'lodash/fp/flow';
import isFunction from 'lodash/fp/isFunction';
import omitBy from 'lodash/fp/omitBy';
import set from 'lodash/fp/set';
import uniq from 'lodash/fp/uniq';

const CSS_ID = 'FS_TOOL_TIP';
const ANIMATION_DURATION = '.3s';
const COOKIE_NAME = 'fs-tool-tips';

const append = (concat as any).convert({ rearg: true });

const isBlank = v => v === '' || v === null || v === undefined;

function ifAllowedFunctionalCookies(cb) {
	window['FS'] &&
		window['FS']?.['GDPR'] &&
		window['FS']?.['GDPR'].ifAllowed &&
		window['FS']?.['GDPR'].ifAllowed('functional', cb);
}

function addCss({ css, id }: { css: string; id: string }) {
	const style = document.createElement('style');
	style.id = id;
	style.innerHTML = css;
	document.head.appendChild(style);
}

const getCss = ({ arrowSize = 15 }) => `
.fs-tooltip-container {
  background: transparent;
  position: absolute;
  bottom: 0;
  height: 5px;
  width: auto;
	min-width: ${2 * arrowSize}px;
  z-index: 10000;
	opacity: 0;
	transition: opacity ${ANIMATION_DURATION} ease, transform ${ANIMATION_DURATION} ease;
	transform: translate(0px, 20px);
}

.fs-tooltip-container:before {
  content: "";
  border: solid ${arrowSize + 1}px transparent;
  border-top-width: 0;
  border-bottom-color: #D8D8D8;
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -${arrowSize + 1}px;
  margin-top: 1px;
}

.fs-tooltip-container:after {
  content: "";
  border: solid ${arrowSize}px transparent;
  border-top-width: 0;
  border-bottom-color: #F5F5F5;
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -${arrowSize}px;
  margin-top: 1px;
}

.fs-tooltip-container--screen {
  position: fixed;
  display: flex;
  flex-direction: row;
  bottom: 50px;
  left: 50px;
  right: 50px;
  height: 0px;
  align-items: flex-end;
  justify-content: flex-start;
	transition: opacity ${ANIMATION_DURATION} ease, transform ${ANIMATION_DURATION} ease;
	transform: translate(-100px, 0px);
}

.fs-tooltip {
  box-sizing: border-box;
  flex-direction: column;
	gap: 15px;
  align-items: stretch;
  padding: 20px;
  width: 335px;
  position: absolute;
  background: #F5F5F5;
  border: 1px solid #D8D8D8;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 0px;
  color: #000;
  white-space: normal;
  word-wrap: normal;
  word-break: normal;
  top: ${arrowSize}px;
}

@media only screen and (min-width: 701px) {
	.fs-tooltip {
		padding: 30px 25px;
	}
}

.fs-tooltip[open] {
  display: flex;
}

.fs-tooltip form {
	margin: 0;
	padding: 0;
}

.fs-tooltip-container--screen .fs-tooltip {
  top: unset;
  left: unset;
  right: unset;
  bottom: 0;
}

.fs-tooltip__header {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-family: Neue Helvetica, helvetica, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 1.5;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin: 0;
}

@media only screen and (min-width: 701px) {
	.fs-tooltip__header {
		font-size: 12px;
	}
}

.fs-tooltip__header .icon {
  font-size: 18px;
  line-height: 1;
}

.fs-tooltip__title {
}

.fs-tooltip__dismiss-button {
  height: 14px;
  width: 14px;
  margin-left: auto;
}

.fs-tooltip__dismiss-button .icon {
	background: none;
	border: none;
	border-radius: 0;
	color: inherit;
	cursor: pointer;
	font: inherit;
	padding: 0;
  height: 14px;
  width: 14px;
  font-size: 14px;
  line-height: 1;
}

.fs-tooltip__text {
  font-family: Monotype Garamond, garamond, serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.67;
  letter-spacing: 0.5px;
  margin: 0;
}

.fs-tooltip__summary-block {
	display: flex;
  flex-direction: row;
	gap: 15px;
}

.fs-tooltip__summary-block__image {
	width: 60px;
	height: 75px;
	flex-grow: 0;
	flex-shrink: 0;
}

@media only screen and (min-width: 701px) {
	.fs-tooltip__summary-block__image {
		width: 80px;
		height: 100px;
	}
}

.fs-tooltip__summary-block__image img {
	object-fit: cover;
	width: 100%;
	height: 100%;
}
}

.fs-tooltip__summary-block__content {
	display: flex;
  flex-direction: column;
}

.fs-tooltip__summary-block__title {
	font-family: Neue Helvetica, helvetica, sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 12px;
	line-height: 1.5;
	letter-spacing: 3px;
	text-transform: uppercase;
	margin: 0 0 10px;
}

.fs-tooltip__summary-block__text {
	font-family: Neue Helvetica, helvetica, sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 10px;
	line-height: 1.3;
	letter-spacing: 3px;
	text-transform: uppercase;
	color: #2D2D2D;
	margin: 0 0 15px;
}

.fs-tooltip__summary-block__action {
	background: none;
	border: none;
	border-radius: 0;
	color: inherit;
	cursor: pointer;
	font: inherit;
	margin: 0;
	padding: 0;
	font-family: Neue Helvetica, helvetica, sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 10px;
	line-height: 1.5;
	text-align: center;
	letter-spacing: 3px;
	text-transform: uppercase;
	border-bottom: solid 1px;
}

.fs-tooltip__actions {
  display: flex;
  flex-direction: row;
  row-gap: 20px;
  column-gap: 10px;
  justify-content: flex-start;
}

.fs-tooltip__actions--list {
	flex-direction: column;
}

.fs-tooltip  .CTA--primary--light {
  align-items: center;
  background-color: #000;
  border: 1px solid #000;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-family: Neue Helvetica,helvetica,sans-serif;
  font-size: .625rem;
  font-style: normal;
  font-weight: 700;
  justify-content: center;
  letter-spacing: .3em;
  line-height: 1.3em;
  min-width: unset;
  padding: 8px 20px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color .3s ease-out,color .3s ease-out,border-color .3s ease-out;
}

.fs-tooltip .CTA--primary--light:hover,
.fs-tooltip .CTA--primary--light:focus {
  background-color: #fff;
  border-color: #000;
  color: #000;
}

.fs-tooltip .CTA--secondary--light {
  align-items: center;
  background-color: #fff;
  border: 1px solid #000;
  box-sizing: border-box;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  font-family: Neue Helvetica,helvetica,sans-serif;
  font-size: .625rem;
  font-style: normal;
  font-weight: 700;
  justify-content: center;
  letter-spacing: .3em;
  line-height: 1.3em;
  min-width: unset;
  padding: 8px 20px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color .3s ease-out,color .3s ease-out,border-color .3s ease-out;
}

@media only screen and (min-width: 701px) {
	.fs-tooltip  .CTA--primary--light,
	.fs-tooltip .CTA--secondary--light {
		padding: 12px 20px;
	}
}

.fs-tooltip .CTA--secondary--light:hover,
.fs-tooltip .CTA--secondary--light:focus {
  background-color: #000;
  border-color: #000;
  color: #fff;
}
`;

function getZIndex(element) {
	const zIndex = getComputedStyle(element).getPropertyValue('z-index');
	if ((!zIndex || zIndex === 'auto') && element.parentElement) {
		return getZIndex(element.parentElement);
	}
	return zIndex;
}

interface ToolTipAction {
	id?: string;
	type?: 'primary' | 'secondary';
	text: string;
	onClick: (evt) => void;
}

interface ToolTipSummaryBlock {
	image?: string;
	title?: string;
	text?: string;
	action: ToolTipAction;
}

interface ToolTipContent {
	title: string;
	titleIcon?: string;
	text?: string;
	summaryBlock?: ToolTipSummaryBlock;
	dismissCtaText: string;
	actions?: ToolTipAction[];
	dismissIcon?: boolean;
}

type DismissOnAnchorElementEvent = 'click' | 'change' | 'focus' | 'blur';

interface CreateToolTip extends ToolTipContent {
	id?: string;
	anchorElement: string | Element;
	dismissOnAnchorElementEvents: Array<DismissOnAnchorElementEvent>;
	arrowPosition: 'left' | 'right' | 'center';
	arrowSize?: number;
	onDismiss: ({ id }) => { id: string } | void;
}

interface ToolTip {
	id: string;
	values: CreateToolTip;
	toolTip: ReturnType<typeof createToolTip>;
	active: boolean;
	isSession: boolean;
	dismissTimeout?: number;
}

interface AddToolTip extends CreateToolTip {
	isSession: boolean;
	dismissTimeout?: number;
}

function addActionIdString({ id }: ToolTipAction): string {
	return id ? `id="${id}"` : '';
}

function getInnerHtml({
	title,
	titleIcon,
	text,
	summaryBlock,
	dismissCtaText,
	actions = [],
	dismissIcon,
}: ToolTipContent): string {
	const hasSummaryBlock =
		summaryBlock &&
		(summaryBlock.image || summaryBlock.title || summaryBlock.text || summaryBlock.action.text);

	return [
		`<div class="fs-tooltip__header">`,
		titleIcon && `<div class="icon icon-${titleIcon}"></div>`,
		title && `<div class="fs-tooltip__title">${title}</div>`,
		dismissIcon &&
			`<div class="fs-tooltip__dismiss-button"><form method="dialog"><button class="icon icon-close" aria-label="${dismissCtaText}"></button></form></div>`,
		`</div>`,

		hasSummaryBlock &&
			[
				`<div class="fs-tooltip__summary-block">`,
				summaryBlock.image &&
					`<div class="fs-tooltip__summary-block__image"><img src="${summaryBlock.image}" alt="${summaryBlock.title}" /></div>`,
				`<div class="fs-tooltip__summary-block__content">`,
				summaryBlock.title &&
					`<div class="fs-tooltip__summary-block__title">${summaryBlock.title}</div>`,
				summaryBlock.text &&
					`<div class="fs-tooltip__summary-block__text">${summaryBlock.text}</div>`,
				summaryBlock.action.text &&
					`<div class="fs-tooltip__summary-block__actions"><button ${addActionIdString(
						summaryBlock.action
					)} type="button" class="fs-tooltip__summary-block__action" data-action-index="summary-block-action">${
						summaryBlock.action.text
					}</button></div>`,
				`</div>`,
				`</div>`,
			].join(''),

		text && `<div class="fs-tooltip__text">${text}</div>`,

		actions.length > 1 &&
			[
				`<div class="fs-tooltip__actions fs-tooltip__actions--list">`,
				actions
					.map(
						(action, index) =>
							`<button ${addActionIdString(action)} class="CTA--${
								action.type || 'primary'
							}--light" data-action-index="${index}">${action.text}</button>`
					)
					.join(''),
				`</div>`,
			].join(''),

		(!dismissIcon || actions.length === 1) && [
			`<div class="fs-tooltip__actions">`,
			actions.length === 1 &&
				`<button type="button" class="CTA--${
					actions[0].type || 'primary'
				}--light" data-action-index="0" ${addActionIdString(actions[0])}>${
					actions[0].text
				}</button>`,
			`<form method="dialog">`,

			!dismissIcon &&
				`<button class="CTA--${
					actions.length > 0 ? 'secondary' : 'primary'
				}--light">${dismissCtaText}</button>`,
			`</form>`,
			`</div>`,
		],
	]
		.flat()
		.filter(Boolean)
		.join('');
}

function getAnchorElement(anchorElementOrSelector) {
	if (typeof anchorElementOrSelector === 'string') {
		return Array.from(document.querySelectorAll(anchorElementOrSelector)).find(el => {
			const { width, height } = el.getBoundingClientRect();
			return width * height > 0;
		});
	}
	return anchorElementOrSelector;
}

function repositionToolTip({
	dialog,
	arrowPosition,
}: {
	dialog: HTMLElement;
	arrowPosition: 'left' | 'right' | 'center';
}) {
	const padding = 0;
	let boundingClientRect = dialog.getBoundingClientRect();

	dialog.style.right = 'unset';
	if (arrowPosition === 'center') {
		dialog.style.left = `calc(50% - ${boundingClientRect.width / 2}px)`;
	} else {
		dialog.style.left = 'unset';
		dialog.style[arrowPosition] = '0';
	}

	boundingClientRect = dialog.getBoundingClientRect();

	const leftSpill = boundingClientRect.x - padding;
	const rightSpill =
		document.body.clientWidth - padding - (boundingClientRect.x + boundingClientRect.width);
	const overSpill = Math.min(leftSpill, rightSpill);

	if (overSpill < 0) {
		if (arrowPosition === 'center') {
			dialog.style.left = 'unset';
			dialog.style.right = 'unset';
			dialog.style[leftSpill < 0 ? 'left' : 'right'] = `calc(50% - ${
				boundingClientRect.width / 2
			}px - ${overSpill}px)`;
		} else {
			dialog.style[arrowPosition] = `${overSpill}px`;
		}
	}
}

export function createToolTip({
	id: initialId,
	title,
	titleIcon,
	text,
	summaryBlock,
	dismissCtaText = 'Got It',
	dismissIcon = false,
	actions = [],
	anchorElement: anchorElementOrSelector,
	dismissOnAnchorElementEvents = [],
	arrowPosition = 'center', // 'left' | 'right' | 'center'
	arrowSize = 15,
	onDismiss = () => {},
}: CreateToolTip) {
	if (!document.getElementById(CSS_ID)) {
		addCss({ css: getCss({ arrowSize }), id: CSS_ID });
	}

	const id = initialId ?? Date.now();

	let anchorElement = getAnchorElement(anchorElementOrSelector);

	const toolTip = document.createElement('div');
	toolTip.className = anchorElement ? 'fs-tooltip-container' : 'fs-tooltip-container--screen';
	if (anchorElement) {
		toolTip.style.zIndex = getZIndex(anchorElement);
	}

	const dialog = document.createElement('dialog');
	dialog.id = `fs-tooltip-${id}`;
	dialog.className = 'fs-tooltip';
	dialog.open = true;
	dialog.innerHTML = getInnerHtml({
		title,
		titleIcon,
		text,
		summaryBlock,
		dismissCtaText,
		actions,
		dismissIcon,
	});
	dialog.ariaLive = 'polite';

	toolTip.appendChild(dialog);

	function handleClick(evt) {
		const actionIndex = evt.target.dataset.actionIndex;
		if (!actionIndex) {
			return;
		}

		if (actionIndex === 'summary-block-action' && summaryBlock) {
			return summaryBlock.action.onClick(evt);
		}

		const actionIndexNum = parseInt(actionIndex, 10);

		if (actions[actionIndexNum]) {
			return actions[actionIndexNum].onClick(evt);
		}
	}

	function setPosition() {
		if (!anchorElement) {
			return;
		}
		const boundingClientRect = anchorElement.getBoundingClientRect();

		toolTip.style.display =
			boundingClientRect.height + boundingClientRect.width > 0 ? 'block' : 'none';

		toolTip.style.top =
			(document?.scrollingElement || document.body).scrollTop +
			boundingClientRect.top +
			boundingClientRect.height +
			'px';

		toolTip.style.left = document.body.scrollLeft + boundingClientRect.left + 'px';
		toolTip.style.width = boundingClientRect.width + 'px';
	}

	function handleWindowResize(evt) {
		setPosition();
		repositionToolTip({ dialog, arrowPosition });
	}

	let scrollTimeout = 0;

	function handleWindowScroll(evt) {
		setPosition();
		if (scrollTimeout) {
			window.clearTimeout(scrollTimeout);
		}
		scrollTimeout = window.setTimeout(setPosition, 350);
	}

	function handleAnchorElementEvent(evt) {
		if (evt.target === anchorElement) {
			dismiss();
		}
	}

	function dismiss() {
		if (anchorElement) {
			dismissOnAnchorElementEvents.forEach(eventName => {
				anchorElement.removeEventListener(eventName, handleAnchorElementEvent);
			});
			window.removeEventListener('resize', handleWindowResize);
			window.removeEventListener('scroll', handleWindowScroll);
		}
		if (scrollTimeout) {
			window.clearTimeout(scrollTimeout);
		}
		toolTip.remove();
		onDismiss({ id });
	}

	dialog.addEventListener('close', dismiss);
	dialog.addEventListener('click', handleClick);
	document.body.appendChild(toolTip);

	function setAnchorElement(_anchorElementOrSelector) {
		anchorElement = getAnchorElement(_anchorElementOrSelector);

		dismissOnAnchorElementEvents.forEach(eventName => {
			anchorElement.removeEventListener(eventName, handleAnchorElementEvent);
		});

		window.removeEventListener('resize', handleWindowResize);
		window.removeEventListener('scroll', handleWindowScroll);

		if (anchorElement) {
			setPosition();
			repositionToolTip({ dialog, arrowPosition });
			window.addEventListener('resize', handleWindowResize);
			window.addEventListener('scroll', handleWindowScroll);

			dismissOnAnchorElementEvents.forEach(eventName => {
				anchorElement.addEventListener(eventName, handleAnchorElementEvent);
			});
		}
	}

	setAnchorElement(anchorElementOrSelector);

	setTimeout(() => {
		requestAnimationFrame(() => {
			toolTip.style.opacity = '1';
			toolTip.style.transform = 'translate(0px, 0px)';
		});
	});

	return {
		id,
		toolTip,
		dismiss,
		setAnchorElement,
	};
}

export default function ToolTipsController() {
	let toolTips: ToolTip[] = [];
	let activeToolTipIndex = -1;
	let _dismissedIds: string[] = [];

	const getDismissedIds = (): Promise<string[]> => {
		return new Promise(resolve => {
			const timeout = setTimeout(() => resolve(_dismissedIds), 200);
			ifAllowedFunctionalCookies(
				flow(
					() => Cookies.get(COOKIE_NAME) || '[]',
					JSON.parse,
					dismissedIds => {
						clearTimeout(timeout);
						resolve([..._dismissedIds, ...dismissedIds]);
					}
				)
			);
		});
	};

	const addDismissedId = ({ id, isSession }): Promise<string[]> => {
		return new Promise(resolve => {
			_dismissedIds = [id, ..._dismissedIds];

			if (!isSession) {
				return resolve(_dismissedIds);
			}

			const timeout = setTimeout(() => resolve(_dismissedIds), 500);
			ifAllowedFunctionalCookies(
				flow(
					() => clearTimeout(timeout),
					() => Cookies.get(COOKIE_NAME) || '[]',
					JSON.parse,
					append(id),
					uniq,
					dismissedIds => {
						Cookies.set(COOKIE_NAME, JSON.stringify(dismissedIds));
						resolve([..._dismissedIds, ...dismissedIds] as string[]);
					}
				)
			);
		});
	};

	const add = flow(
		omitBy(isBlank),
		({ isSession = false, dismissTimeout, ...values }: AddToolTip) => {
			getDismissedIds().then(dismissedIds => {
				if (values.id && dismissedIds.includes(values.id)) {
					return;
				}

				const activeToolTip = getActiveToolTip();

				// if there is an ID and the activeToolTip has the same ID - reset the anchor element
				if (activeToolTip && values.id && activeToolTip.id === values.id) {
					activeToolTip.toolTip.setAnchorElement(values.anchorElement);
					return;
				}

				return setToolTips(
					append({
						id: values.id,
						values,
						active: true,
						isSession,
						dismissTimeout,
					})
				);
			});
		}
	);

	const run = () => {
		let timeout;
		const nextActiveToolTipIndex = toolTips.findIndex(({ active }) => active);
		if (activeToolTipIndex === nextActiveToolTipIndex) {
			return;
		}
		activeToolTipIndex = nextActiveToolTipIndex;
		const activeToolTip = (activeToolTipIndex >= 0 && toolTips[activeToolTipIndex]) || null;

		if (!activeToolTip) {
			return;
		}

		const onDismiss = ({ id }) => {
			if (timeout) {
				clearTimeout(timeout);
			}
			dismissToolTip();
			if (activeToolTip.values.onDismiss) {
				activeToolTip.values.onDismiss({ id });
			}
		};

		const toolTip = createToolTip({
			...activeToolTip.values,
			onDismiss,
		});

		toolTips = set([activeToolTipIndex, 'toolTip'], toolTip)(toolTips);

		if (activeToolTip?.dismissTimeout) {
			timeout = setTimeout(() => {
				toolTip.dismiss();
			}, activeToolTip.dismissTimeout);
		}
	};

	const setToolTips = value => {
		toolTips = isFunction(value) ? value(toolTips) : value;
		run();
	};

	const getActiveToolTip = () => {
		return toolTips[activeToolTipIndex];
	};

	const dismissToolTip = () => {
		const activeToolTip = getActiveToolTip();

		let nextToolTips = set([activeToolTipIndex, 'active'], false)(toolTips);

		if (activeToolTip?.id) {
			addDismissedId({ id: activeToolTip.id, isSession: activeToolTip?.isSession }).then(
				dismissedIds => {
					nextToolTips = filter(({ id }) => !dismissedIds.includes(id))(nextToolTips) as ToolTip[];
					setToolTips(nextToolTips);
				}
			);
		} else {
			setToolTips(nextToolTips);
		}
	};

	run();

	return {
		add,
		createToolTip,
		getActiveToolTip: () => getActiveToolTip()?.toolTip,
		dismissActiveToolTip: () => getActiveToolTip()?.toolTip.dismiss(),
	};
}
